import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HistogramComponent } from './histogram/histogram.component';
import { PieChartComponent } from './pie-chart/pie-chart.component';
import { RadarComponent } from './radar/radar.component';
import { SmallLineChartComponent } from './small-line-chart/small-line-chart.component';
import { SmallPieChartComponent } from './small-pie-chart/small-pie-chart.component';


@NgModule({
    declarations: [HistogramComponent, PieChartComponent, RadarComponent, SmallLineChartComponent, SmallPieChartComponent],
    imports: [
        CommonModule
    ],
    exports: [HistogramComponent, PieChartComponent, RadarComponent, SmallLineChartComponent, SmallPieChartComponent]
})
export class ChartsModule {}
